/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices move based on Points Per Million (PPM), averaged over a driver or constructor's last three races. Score well relative to your price and it tends to rise; underperform it and it tends to fall. The game applies these changes automatically after each race, rewarding form rather than reputation alone.`)
};

const es_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los precios se mueven según los Puntos Por Millón (PPM), promediados en las últimas tres carreras de un piloto o constructor. Si puntúa bien en relación con su precio, tiende a subir; si rinde por debajo, tiende a bajar. El juego aplica estos cambios automáticamente después de cada carrera, premiando la forma y no solo la reputación.`)
};

const de_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise bewegen sich auf Basis der Punkte pro Million (PPM), gemittelt über die letzten drei Rennen eines Fahrers oder Konstrukteurs. Punktet er im Verhältnis zu seinem Preis gut, steigt der Preis tendenziell; bleibt er darunter, fällt er tendenziell. Das Spiel wendet diese Änderungen automatisch nach jedem Rennen an und belohnt damit Form statt allein den Ruf.`)
};

const nl_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen bewegen op basis van Punten Per Miljoen (PPM), gemiddeld over de laatste drie races van een coureur of constructeur. Scoor je goed ten opzichte van je prijs, dan stijgt deze meestal; presteer je eronder, dan daalt hij meestal. Het spel voert deze wijzigingen automatisch door na elke race, waarbij vorm wordt beloond in plaats van alleen reputatie.`)
};

const fr_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les prix évoluent selon les Points Par Million (PPM), moyennés sur les trois dernières courses d'un pilote ou d'un constructeur. Bien scorer par rapport à son prix tend à le faire monter ; sous-performer tend à le faire baisser. Le jeu applique ces changements automatiquement après chaque course, récompensant la forme du moment plutôt que la seule réputation.`)
};

const it_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I prezzi si muovono in base ai Punti Per Milione (PPM), mediati sulle ultime tre gare di un pilota o costruttore. Se il rendimento è buono rispetto al prezzo, questo tende a salire; se è sotto le aspettative, tende a scendere. Il gioco applica questi cambiamenti automaticamente dopo ogni gara, premiando la forma del momento e non solo la reputazione.`)
};

const pt_br2_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os preços se movem com base nos Pontos Por Milhão (PPM), calculados sobre as últimas três corridas de um piloto ou construtor. Pontuar bem em relação ao seu preço tende a fazê-lo subir; ficar abaixo disso tende a fazê-lo cair. O jogo aplica essas mudanças automaticamente depois de cada corrida, recompensando a forma, não só a reputação.`)
};

const pt_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os preços movem-se com base nos Pontos Por Milhão (PPM), calculados sobre as últimas três corridas de um piloto ou construtor. Se pontuar bem face ao seu preço, este tende a subir; se ficar aquém, tende a descer. O jogo aplica estas alterações automaticamente após cada corrida, recompensando a forma e não apenas a reputação.`)
};

const ja_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格は、ドライバーやコンストラクターの直近3レースの平均Points Per Million（PPM）に基づいて変動します。価格に見合う以上の得点を挙げれば値上がりしやすく、下回れば値下がりしやすくなります。ゲームはレースごとにこの変更を自動で適用し、評判だけでなく実際の調子が反映される仕組みです。`)
};

const zh_f1_bb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格变动依据的是车手或车队最近三场比赛的平均每百万积分（PPM）。相对身价表现出色，价格往往会上涨；表现不及身价，价格则往往会下跌。游戏会在每场比赛后自动应用这些调整，奖励的是近期状态，而不只是名气。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq1_a", locale)
	if (locale === "en") return en_f1_bb_faq1_a(inputs)
	if (locale === "es") return es_f1_bb_faq1_a(inputs)
	if (locale === "de") return de_f1_bb_faq1_a(inputs)
	if (locale === "nl") return nl_f1_bb_faq1_a(inputs)
	if (locale === "fr") return fr_f1_bb_faq1_a(inputs)
	if (locale === "it") return it_f1_bb_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq1_a(inputs)
	if (locale === "pt") return pt_f1_bb_faq1_a(inputs)
	if (locale === "ja") return ja_f1_bb_faq1_a(inputs)
	return zh_f1_bb_faq1_a(inputs)
};